
// Creamos variables para localizar errores fácilmente

export const CREATE = "CREATE"
export const UPDATE = "UPDATE"
export const UPDATE_RETURN_ONE = "UPDATE_RETURN_ONE"
export const DELETE = "DELETE"
export const DELETE_POST = "DELETE_POST"
export const FETCH_ALL = "FETCH_ALL"
export const FETCH_MY_POSTS = "FETCH_MY_POSTS"
export const FETCH_ALL_POSTS = "FETCH_ALL_POSTS"
export const FETCH_POST = "FETCH_POST"
export const FETCH_BY_SEARCH = "FETCH_BY_SEARCH"
export const FETCH_BY_PAGE = "FETCH_BY_PAGE"

export const UPDATE_SCORES = "UPDATE_SCORES"
export const UPDATE_SCORE_PUNTOS = "UPDATE_SCORE_PUNTOS"

export const START_LOADING = "START_LOADING"
export const END_LOADING = "END_LOADING"

export const AUTH = "AUTH"
export const LOGOUT = "LOGOUT"

export const TEXT = "TEXT"


